import "./communique.scss";
import {
  ArrowBackRounded,
  CallMadeOutlined,
  CloudOff,
  DeleteOutline,
  FeedbackRounded,
  FilterAltOutlined,
  ForwardToInboxOutlined,
  MailOutlined,
  MoreVert,
  Search,
} from "@mui/icons-material";
import { Divider, Stack, Box, Tooltip, Skeleton } from "@mui/material";
import React, { useReducer, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NewCommunication from "./NewCommunication.tsx";
import UpdateCommunication from "./UpdateCommunication.tsx";
import SingleCommunication from "./SingleCommunication.tsx";
import toast from "react-hot-toast";
import { API_COMMUNIQUE } from "../../apiCaller/communique.Caller.js";
import { accountService } from "../../_services/accountServices.js";
import { CommuniqueType, requestType } from "../../types/GlobalType.ts";
import _ from "lodash";
import moment from "moment";
import MyLoading from "../../component/loader/MyLoading.tsx";
import ConnexionErrorDiv from "../../component/nodata/ConnexionErrorDiv.js";

const ACTION_TYPES = {
  activateDelete: "activateDelete",
  selectedItem: "selectedItem",
  initalized: "initalized",
};

const initialState = {
  openDelete: false,
  selected: 0,
};

function deleteReducer(state, action) {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.activateDelete:
      return { ...state, openDelete: true };
    case ACTION_TYPES.selectedItem:
      return { ...state, selected: payload };
    case ACTION_TYPES.initalized:
      return initialState;

    default:
      break;
  }
}

const Communique = () => {
  const [openNew, setOpenNew] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openSingle, setOpenSingle] = useState(false);
  const [allCommunique, setallCommunique] = useState<CommuniqueType[]>([]);
  const [filteredValue, setfilteredValue] = useState<string>("tous");
  const [searchValue, setsearchValue] = useState<string>("");
  const [singleData, setsingleData] = useState<CommuniqueType>();
  const [state, dispatch] = useReducer(deleteReducer, initialState);

  const [selectedCom, setSelectedCom] = useState<string>("aucun");

  const [reloadState, forceReload] = useReducer((x) => x + 1, 0);

  const navigate = useNavigate();

  const [stateFetch, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const [stateDel, setStateDel] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const handleSelect = (val: string) => {
    if (val === selectedCom) setSelectedCom("aucun");
    else setSelectedCom(val);
  };

  const fetchAllCommunique = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    API_COMMUNIQUE.COMMUNIQUE.getAll(token)
      .then((response) => {
        // console.log(response);
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        let empyData: [] = [];

        if (response.data === "") {
          setallCommunique(empyData);
        } else {
          setallCommunique(response.data.data);
        }
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        } else if (err.response.status === 403) {
          toast.error("Votre session a expiré, veuillez vous reconnectez");
          accountService.logout();
          navigate("/", { replace: true });
        } else {
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard",
          );
        }
      });
  };

  let orderedData: CommuniqueType[] = [];
  let sendMsg: CommuniqueType[] = [];
  let draftMsg: CommuniqueType[] = [];
  let parentMsg: CommuniqueType[] = [];
  let personnelMsg: CommuniqueType[] = [];
  let bothMsg: CommuniqueType[] = [];

  if (allCommunique.length > 1) {
    orderedData = _.orderBy(allCommunique, ["communique_created_at"], ["desc"]);

    for (let value of allCommunique) {
      if (value.communique_status) sendMsg.push(value);
      if (!value.communique_status) draftMsg.push(value);
      if (value.type_destinateur_id === 1) parentMsg.push(value);
      if (value.type_destinateur_id === 2) personnelMsg.push(value);
      if (value.type_destinateur_id === 3) bothMsg.push(value);
    }
  }

  const handleChange = (e) => {
    setfilteredValue(e.target.value);
  };

  let dest_type_value: any, comm_status_value: any;
  if (filteredValue === "send") {
    comm_status_value = 1;
  } else if (filteredValue === "draft") {
    comm_status_value = 0;
  } else if (filteredValue === "parent") {
    dest_type_value = 1;
  } else if (filteredValue === "personnel") {
    dest_type_value = 2;
  } else if (filteredValue === "both") {
    dest_type_value = 3;
  }

  let filteredData = orderedData.filter((value) => {
    if (filteredValue === "tous") return orderedData;
    else {
      return (
        value.type_destinateur_id === dest_type_value ||
        value.communique_status === comm_status_value
      );
    }
  });

  const handleDelete = async () => {
    if (selectedCom === "aucun") {
      return toast.error("Aucun communiqué n'est selectionné", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
        },
      });
    }

    setStateDel({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    API_COMMUNIQUE.COMMUNIQUE.delete(state.selected, token)
      .then((response) => {
        setSelectedCom("aucun");
        setStateDel({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        toast.success("Suppression du communiqué effectuée ", {
          duration: 4000,
        });
        dispatch({ type: ACTION_TYPES.initalized });
        forceReload();
      })
      .catch((err) => {
        setStateDel({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        } else if (err.response.status === 403) {
          toast.error("Votre session a expiré, veuillez vous reconnectez");
          accountService.logout();
          navigate("/", { replace: true });
        } else {
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard" + err,
          );
        }
      });
  };

  React.useEffect(() => {
    fetchAllCommunique();
  }, [reloadState]);

  const skeletonHeader = (
    <>
      <Skeleton
        variant="rounded"
        height={25}
        width={250}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={25}
        width={250}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </>
  );
  const skeletonLeft = (
    <div className="msgList">
      <div className="com_title">
        <Skeleton
          variant="rounded"
          height={25}
          width={250}
          sx={{ marginTop: "5px", marginRight: "10px" }}
        />
        <Skeleton
          variant="rounded"
          height={25}
          width={250}
          sx={{ marginTop: "5px", marginRight: "10px" }}
        />
      </div>
      <Skeleton
        variant="rounded"
        height={80}
        width={"100%"}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={80}
        width={"100%"}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={80}
        width={"100%"}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={80}
        width={"100%"}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={80}
        width={"100%"}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </div>
  );
  const skeletonRight = (
    <div className="dialogMsg">
      <Skeleton
        variant="rounded"
        height={35}
        width={"100%"}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={500}
        width={"100%"}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </div>
  );

  return (
    <>
      {stateFetch.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <>
          <Box
            bgcolor="#eee"
            flex={5}
            p={1}
            height="100%"
            sx={{ marginLeft: "200px", marginTop: "66px" }}
          >
            {stateDel.isLoading && <MyLoading isLoading={stateDel.isLoading} />}
            <Stack direction="row" justifyContent="space-between">
              {stateFetch.isLoading ? (
                skeletonHeader
              ) : (
                <>
                  <div className="homeMenu">
                    <Link to="/" style={{ marginTop: "5px" }}>
                      <ArrowBackRounded
                        sx={{
                          color: "#0091EA",
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                        }}
                      />
                    </Link>
                    <div className="homeTitleItem">
                      <span className="homeTitle"> Communiqué</span>
                    </div>
                    <div className="homeTitleItem2">
                      {filteredValue === "tous" && "tous"}
                      {filteredValue === "draft" && "brouillon"}
                      {filteredValue === "send" && "envoyé"}
                      {filteredValue === "both" && "personnel & parent"}
                      {filteredValue === "parent" && "parent"}
                      {filteredValue === "personnel" && "personnel"}
                    </div>
                  </div>
                  <div className="Searchbar_">
                    <Search className="icon" />
                    <input
                      placeholder="Rechercher"
                      type="text"
                      value={searchValue}
                      onChange={(e) => setsearchValue(e.target.value)}
                    />
                  </div>
                </>
              )}
            </Stack>

            <Divider sx={{ marginTop: "5px", marginBottom: "10px" }} />

            <div className="containerMsg">
              {stateFetch.isLoading ? (
                skeletonLeft
              ) : (
                <div className="msgList">
                  <div className="com_title">
                    <span>Liste</span>
                    <div className="com_option">
                      <div className="com_del">
                        <DeleteOutline
                          className="icoDel"
                          onClick={() =>
                            dispatch({ type: ACTION_TYPES.activateDelete })
                          }
                        />
                        {state.openDelete && (
                          <>
                            <span onClick={handleDelete}>Supprimer</span> |{" "}
                            <span
                              onClick={() => {
                                setSelectedCom("aucun");
                                dispatch({ type: ACTION_TYPES.initalized });
                              }}
                            >
                              Annuler
                            </span>
                          </>
                        )}
                      </div>
                      {!state.openDelete && (
                        <div className="filter">
                          <select
                            name="filter"
                            value={filteredValue}
                            onChange={handleChange}
                          >
                            <option value="tous">Tous</option>
                            <option value="send">Envoyés</option>
                            <option value="draft">Brouillons</option>
                            <option value="parent">Parents</option>
                            <option value="personnel">Enseignants</option>
                            <option value="both">Enseignants-Parents</option>
                          </select>
                          <FilterAltOutlined />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="listMsg">
                    {stateFetch && (
                      <>
                        {filteredData.length !== 0 ? (
                          <>
                            {filteredData
                              .filter(
                                (value) =>
                                  value.contenu
                                    .toLowerCase()
                                    .includes(searchValue.toLowerCase()) ||
                                  value.objet
                                    .toLowerCase()
                                    .includes(searchValue.toLowerCase()),
                              )
                              .map((item, index) => {
                                return (
                                  <div className="com_content" key={index}>
                                    <div className="box_msg">
                                      {state.openDelete && (
                                        <div
                                          // className={
                                          //   selectedCom === index.toString()
                                          //     ? "filledCase"
                                          //     : "case"
                                          // }
                                          className="case"
                                          onClick={() => {
                                            handleSelect(index.toString());

                                            dispatch({
                                              type: ACTION_TYPES.selectedItem,
                                              payload: item.communique_id,
                                            });
                                          }}
                                        >
                                          <div
                                            className={
                                              selectedCom === index.toString()
                                                ? "filledCase"
                                                : ""
                                            }
                                          ></div>
                                        </div>
                                      )}
                                      <div
                                        className="left"
                                        onClick={() => {
                                          setsingleData(item);
                                          setOpenSingle(true);
                                        }}
                                      >
                                        {/* <input type="checkbox" name="" id="" /> */}
                                        <div className="message">
                                          <div className="sender small">
                                            <div className="avatar">
                                              <span>A</span>
                                            </div>
                                            <span>
                                              {
                                                item.type_destinateur_designation
                                              }
                                            </span>
                                          </div>
                                          <div className="sender">
                                            <div className="avatar">A</div>
                                          </div>
                                          <div className="text">
                                            <span className="label_recipient">
                                              Cc:{" "}
                                              {
                                                item.type_destinateur_designation
                                              }{" "}
                                            </span>
                                            <span className="label_subject">
                                              {item.objet}
                                            </span>
                                            {item.contenu.slice(0, 300)}...
                                            <span className="date">
                                              {moment(
                                                item.communique_created_at,
                                              ).format("DD-MM-YYYY")}
                                            </span>
                                            {item.communique_status ? (
                                              <>
                                                <span className="label_send">
                                                  Envoyé{" "}
                                                </span>
                                              </>
                                            ) : (
                                              <>
                                                <span className="label_draft">
                                                  Brouillon{" "}
                                                </span>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="icons">
                                        <div>
                                          <Tooltip title={"Modifier"}>
                                            <MoreVert
                                              className="icon"
                                              onClick={() => {
                                                setsingleData(item);
                                                setOpenUpdate(true);
                                              }}
                                            />
                                          </Tooltip>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </>
                        ) : (
                          <div className="com_empty">
                            <CloudOff
                              sx={{ color: "#3c72d5ed", fontSize: "4rem" }}
                            />
                            <span
                              style={{ fontSize: "13px", color: "#3c72d5ed" }}
                            >
                              Aucune donnée disponible
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}

              {stateFetch.isLoading ? (
                skeletonRight
              ) : (
                <div className="dialogMsg">
                  <button onClick={() => setOpenNew(true)}>Nouveau</button>
                  <div className="items_msg">
                    <div className="left_part">
                      <div className="icoContainer">
                        <MailOutlined className="ico" />
                      </div>
                      <span>Total</span>
                    </div>
                    <span>{orderedData.length}</span>
                  </div>
                  <div className="items_msg">
                    <div className="left_part">
                      <div className="icoContainer">
                        <CallMadeOutlined className="ico" />
                      </div>
                      <span>Envoyés</span>
                    </div>
                    <span>{sendMsg.length}</span>
                  </div>
                  <div className="items_msg">
                    <div className="left_part">
                      <div className="icoContainer">
                        <FeedbackRounded className="ico" />
                      </div>
                      <span>Draft</span>
                    </div>
                    <span>{draftMsg.length}</span>
                  </div>
                  <hr />
                  <div className="items_msg">
                    <div className="left_part">
                      <div className="icoContainer">
                        <ForwardToInboxOutlined className="ico" />
                      </div>
                      <span>Parent</span>
                    </div>
                    <span>{parentMsg.length}</span>
                  </div>
                  <div className="items_msg">
                    <div className="left_part">
                      <div className="icoContainer">
                        <ForwardToInboxOutlined className="ico" />
                      </div>
                      <span>Enseignant</span>
                    </div>
                    <span>{personnelMsg.length}</span>
                  </div>
                  <div className="items_msg">
                    <div className="left_part">
                      <div className="icoContainer">
                        <ForwardToInboxOutlined className="ico" />
                      </div>
                      <span>Enseignant & Parent</span>
                    </div>
                    <span>{bothMsg.length}</span>
                  </div>
                </div>
              )}
            </div>
          </Box>

          {openNew && (
            <NewCommunication setOpen={setOpenNew} forceReload={forceReload} />
          )}
          {openSingle && (
            <SingleCommunication setOpen={setOpenSingle} data={singleData} />
          )}
          {openUpdate && (
            <UpdateCommunication
              setOpen={setOpenUpdate}
              data={singleData}
              forceReload={forceReload}
            />
          )}
        </>
      )}
    </>
  );
};

export default Communique;
